export {}

type PollAnswer = {
  survey: string;
  poll_id: number;
};

const surveyForms = document.querySelectorAll<HTMLFormElement>(".f-survey:not(.--submitted)")
surveyForms.forEach(form => {
  const inputs = form.querySelectorAll<HTMLInputElement>(".i-survey__checkbox input")
  const counter = form.querySelector<HTMLElement>(".f-survey__counter-number")

  const checkAndSelectAnswerByCookie = () => {
    const pollId = form.dataset.pollId
    if (!pollId) return

    const getCookie = (name: string): string | null => {
      const cookies = document.cookie.split("; ");
      for (const cookie of cookies) {
        const [key, value] = cookie.split("=");
        if (key === name) {
          return decodeURIComponent(value);
        }
      }
      return null;
    };

    const cookieName = `poll_answer_${pollId}`;
    const cookieValue = getCookie(cookieName);

    if (cookieValue) {
      try {
        const pollData: PollAnswer = JSON.parse(cookieValue);
        const value = pollData.survey
        const input = form.querySelector<HTMLInputElement>(`.f-checkbox__input[value="${value}"]`)
        if (input) input.checked = true
        return true
      } catch (error) {
        console.error("Failed to parse cookie JSON:", error);
        return false
      }
    } else {
      console.log("Cookie not found");
      return false
    }
  }

  if (checkAndSelectAnswerByCookie()) {
    inputs.forEach(input => {
      input.addEventListener("click", (e) => {
        e.preventDefault()
      })
    })
  }

  const inputListeners = new Map<HTMLInputElement, EventListener>();

  const removeInputListeners = () => {
    inputListeners.forEach((callback, input) => {
      input.removeEventListener("change", callback);
    });
    inputListeners.clear();
  };

  inputs.forEach((input) => {
    if (input.checked) form.classList.add("--submitted");

    const handleChange = () => {
      if (form.classList.contains("--submitted")) return;
      form.classList.add("--submitted");
      form.dispatchEvent(new Event("customSubmit"));
      removeInputListeners();
    };

    inputListeners.set(input, handleChange);
    input.addEventListener("change", handleChange);
  });

  form.addEventListener('submit', (e) => {
    e.preventDefault()
  })

  const handleSurveyCalculaion = () => {
    if (!counter) return;

    const totalCount = parseInt(counter.innerHTML) + 1;
    counter.innerHTML = totalCount.toString();

    inputs.forEach((input) => {
      const percentageSpan = input.closest(".f-checkbox")?.querySelector<HTMLElement>(".f-checkbox__count")
      const percentageProgress = input.closest(".i-survey")?.querySelector<HTMLProgressElement>(".i-survey__progress")

        const currentPercentage = parseFloat(percentageSpan.innerText.replace("%", ""))
        const currentVotes = Math.round((currentPercentage / 100) * (totalCount - 1))
        const newVotes = input.checked ? currentVotes + 1 : currentVotes
        const newPercentage = (newVotes / totalCount) * 100

        if (percentageSpan) percentageSpan.innerText = `${newPercentage.toFixed(0)}%`
        if (percentageProgress) percentageProgress.value = newPercentage
    });
  }

  form.addEventListener('customSubmit', () => {
    fetch(form.action, {
      method: form.method,
      body: new FormData(form),
    }).then(response => {
      if (response.ok) handleSurveyCalculaion()
    })
  });
})
